import React from 'react';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
  return (
    <section className="testimonials" id="reviews">
      <div className="container">
        <div className="testimonials-header">
          <span className="section-tag">Testimonials</span>
          <h2 className="section-title">
            What Our <span className="highlight">Clients</span> Say
          </h2>
          <p className="section-subtitle">
            Don't just take our word for it. See how Nodex Global LLC has transformed businesses across various industries.
          </p>
        </div>

        <div className="testimonials-grid">
          <div className="testimonial-card">
            <FaQuoteLeft className="quote-icon" />
            <div className="stars">
              <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
            </div>
            <p className="testimonial-text">
              "Nodex Global transformed our digital presence completely. Their strategic approach to SEO and PPC doubled our inbound leads within just 4 months. The team is incredibly responsive and transparent."
            </p>
            <div className="testimonial-author">
              <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=150" alt="Sarah Johnson" className="author-img" />
              <div className="author-info">
                <h4>Sarah Johnson</h4>
                <p>Marketing Director, TechFlow</p>
              </div>
            </div>
          </div>
          
          <div className="testimonial-card">
            <FaQuoteLeft className="quote-icon" />
            <div className="stars">
              <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
            </div>
            <p className="testimonial-text">
              "Working with Nodex Global LLC has been a game-changer for our e-commerce business. Their Facebook ads campaigns delivered a 400% ROAS, allowing us to scale much faster than we anticipated."
            </p>
            <div className="testimonial-author">
              <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=150" alt="Michael Chen" className="author-img" />
              <div className="author-info">
                <h4>Michael Chen</h4>
                <p>Founder, Elevate Retail</p>
              </div>
            </div>
          </div>
          
          <div className="testimonial-card">
            <FaQuoteLeft className="quote-icon" />
            <div className="stars">
              <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
            </div>
            <p className="testimonial-text">
              "The web development team at Nodex built us a stunning, high-converting website. The combination of beautiful design and solid technical SEO foundation gave us an immediate boost in organic rankings."
            </p>
            <div className="testimonial-author">
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=150" alt="Emma Thompson" className="author-img" />
              <div className="author-info">
                <h4>Emma Thompson</h4>
                <p>CEO, Thompson Services</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
